import _regeneratorRuntime from "@babel/runtime/regenerator";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { getOtherOptionsFromWindow } from "../../utils";
import { getUserDecision } from "../getUserDecision";
import { applyConsent } from "../applyConsent";
/**
 * When a content blocker needs to be unblocked (user click), then
 * we need to get the current consent, and add the newly consent cookies.
 */

function adjustConsentComingFromContentBlocker(_x) {
  return _adjustConsentComingFromContentBlocker.apply(this, arguments);
}

function _adjustConsentComingFromContentBlocker() {
  _adjustConsentComingFromContentBlocker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blocker) {
    var _getOtherOptionsFromW, essentialGroup, groups, currentDecision, _groups$filter, _groups$filter2, essentialGroupObj, newConsent, _iterator, _step, _step$value, groupId, items, _iterator2, _step2, cookieId, _newConsent$groups$gr;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Get all available groups + current decision
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), essentialGroup = _getOtherOptionsFromW.essentialGroup, groups = _getOtherOptionsFromW.groups;
            currentDecision = getUserDecision();
            _groups$filter = groups.filter(function (_ref) {
              var slug = _ref.slug;
              return slug === essentialGroup;
            }), _groups$filter2 = _slicedToArray(_groups$filter, 1), essentialGroupObj = _groups$filter2[0]; // Prepare new consent

            newConsent = currentDecision === false ? {
              // The website owner uses a banner without overlay and content gets unblocked
              // We need to make sure, that also essential cookies got accepted
              groups: _defineProperty({}, essentialGroupObj.id, essentialGroupObj.items.map(function (_ref2) {
                var id = _ref2.id;
                return id;
              }))
            } : {
              groups: currentDecision.consent
            };
            _iterator = _createForOfIteratorHelper(groups);
            _context.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context.next = 31;
              break;
            }

            _step$value = _step.value, groupId = _step$value.id, items = _step$value.items;
            _iterator2 = _createForOfIteratorHelper(items);
            _context.prev = 10;

            _iterator2.s();

          case 12:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 21;
              break;
            }

            cookieId = _step2.value.id;

            if (!(blocker.cookies.indexOf(cookieId) > -1)) {
              _context.next = 19;
              break;
            }

            if (!(((_newConsent$groups$gr = newConsent.groups[groupId]) === null || _newConsent$groups$gr === void 0 ? void 0 : _newConsent$groups$gr.indexOf(cookieId)) > -1)) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("continue", 19);

          case 17:
            newConsent.groups[groupId] = newConsent.groups[groupId] || [];
            newConsent.groups[groupId].push(cookieId);

          case 19:
            _context.next = 12;
            break;

          case 21:
            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](10);

            _iterator2.e(_context.t0);

          case 26:
            _context.prev = 26;

            _iterator2.f();

            return _context.finish(26);

          case 29:
            _context.next = 7;
            break;

          case 31:
            _context.next = 36;
            break;

          case 33:
            _context.prev = 33;
            _context.t1 = _context["catch"](5);

            _iterator.e(_context.t1);

          case 36:
            _context.prev = 36;

            _iterator.f();

            return _context.finish(36);

          case 39:
            _context.next = 41;
            return applyConsent({
              consent: newConsent,
              buttonClicked: "unblock",
              blocker: blocker.id
            });

          case 41:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 33, 36, 39], [10, 23, 26, 29]]);
  }));
  return _adjustConsentComingFromContentBlocker.apply(this, arguments);
}

export { adjustConsentComingFromContentBlocker };